var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',[_c('h3',[_vm._v("Allocation Company")]),_c('br'),_c('b-row',[_c('b-col',[_vm._v("show companies and add company here")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }